<template>
	<div :class="['blank-tile']">
		<div v-if="alert" class="alert-badge" />

		<div class="blank-image" v-if="hasImageSlot">
			<slot name="image"></slot>
		</div>
		<div class="blank-value" v-if="hasValueSlot">
			<slot name="value"></slot>
		</div>
		<div class="blank-title">
			<slot name="title"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'blank-tile',
	props: ['alert'],
	data() {
		return {}
	},
	computed: {
		hasImageSlot() {
			return !!this.$slots['image']
		},
		hasValueSlot() {
			return !!this.$slots['value']
		}
	}
}
</script>

<style lang="scss">
.blank-tile {
	position: relative;
	background: $white;
	width: 100%;
	min-height: 160px;
	border-radius: 20px;
	padding: 10px;
	margin-bottom: 10px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	text-align: center;
	padding: 20px 20px 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	justify-content: center;
	transition: all 0.25s ease-in-out;
	&:hover {
		box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
		transform: translateY(-2px);
	}
	.blank-value {
		font-size: 48px;
		flex-grow: 1;
		display: flex;
		align-items: center;
	}
	.blank-image {
		flex-grow: 1;
		display: flex;
		align-items: center;
		img {
			max-width: 100%;
		}
	}
	.blank-title {
		flex-grow: 0;
		flex-shrink: 0;
	}
	.alert-badge {
		position: absolute;
		top: 15px;
		right: 15px;
		height: 25px;
		width: 25px;
		background: url('../../assets/alert_badge.png') no-repeat;
	}
}
</style>
